module.exports = __webpack_public_path__ + "img/twitter.f55a7c25.svg";